import { Box, List, ListItemButton, ListItemIcon, ListItemText, Stack } from '@mui/material';
import { type FC, type ReactNode } from 'react';

export interface SettingsSection {
  id: string;
  label: string;
  icon: ReactNode;
  isDirty?: boolean;
}

interface SettingsSectionNavProps {
  sections: SettingsSection[];
  activeSection: string;
  onSelect: (sectionId: string) => void;
}

const SettingsSectionNav: FC<SettingsSectionNavProps> = ({ sections, activeSection, onSelect }) => (
  <Box
    component={'nav'}
    aria-label={'Patient settings sections'}
    sx={{
      display: { xs: 'none', md: 'block' },
      position: 'sticky',
      top: (theme) => theme.spacing(11),
      width: 208,
      flexShrink: 0,
    }}
  >
    <List disablePadding>
      {sections.map((section) => (
        <ListItemButton
          key={section.id}
          selected={activeSection === section.id}
          onClick={() => onSelect(section.id)}
          sx={{ borderRadius: 1, mb: 0.25 }}
        >
          <ListItemIcon sx={{ minWidth: 32, color: activeSection === section.id ? 'primary.main' : 'text.secondary' }}>
            {section.icon}
          </ListItemIcon>
          <ListItemText
            primary={section.label}
            primaryTypographyProps={{
              variant: 'body1',
              fontWeight: activeSection === section.id ? 600 : 500,
              color: activeSection === section.id ? 'primary.main' : 'text.secondary',
            }}
          />
          {section.isDirty ? (
            <Stack sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: 'secondary.main' }} />
          ) : null}
        </ListItemButton>
      ))}
    </List>
  </Box>
);

export default SettingsSectionNav;
